var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoOrganizationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/gallery-favorite"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gallery-favorite"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.202 16.8021C16.9693 16.8021 18.402 15.3694 18.402 13.6021C18.402 11.8348 16.9693 10.4021 15.202 10.4021C13.4346 10.4021 12.002 11.8348 12.002 13.6021C12.002 15.3694 13.4346 16.8021 15.202 16.8021Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.002 4.00208H15.202C7.20195 4.00208 4.00195 7.20207 4.00195 15.2021V24.8021C4.00195 32.8021 7.20195 36.0021 15.202 36.0021H24.802C32.8019 36.0021 36.0019 32.8021 36.0019 24.8021V18.4021",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.5942 8.97806C26.0662 7.31406 26.6902 5.25006 28.4182 4.69006C29.3302 4.40206 30.4662 4.64206 31.1062 5.52206C31.7142 4.61006 32.8822 4.38606 33.7942 4.69006C35.5382 5.25006 36.1622 7.31406 35.6342 8.97806C34.8022 11.6021 31.9222 12.9781 31.1222 12.9781C30.3062 12.9781 27.4422 11.6341 26.5942 8.97806Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.07422 31.1222L12.9622 25.8262C14.2262 24.9782 16.0502 25.0742 17.1862 26.0502L17.7142 26.5142C18.9622 27.5862 20.9782 27.5862 22.2262 26.5142L28.8822 20.8022C30.1302 19.7302 32.1462 19.7302 33.3942 20.8022L36.0022 23.0422",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOrganizationIcon);
export default __webpack_public_path__ + "static/media/noOrganizationIcon.2c20b10371fbf13a357c921db4e9b4ab.svg";
export { ForwardRef as ReactComponent };